// @ts-nocheck
import * as $ from 'jquery';
import {SendTicketsConfiguration} from './Models/SendTicketsConfiguration';
import {AddRecipientToCartRequest} from './Models/AddRecipientToCartRequest';
import {Cart} from './Models/Cart';
import {EmployeeSection} from './EmployeeSection';
import {ProductSection} from './ProductSection';
import {RecipientSection} from './RecipientSection';
import {SummarySection} from './SummarySection';
import {Wizard} from './Wizard';
import {NotificationType} from 'Common/NotificationManager';
import Mediator from 'Common/Mediator';

export class SendTicketsApplication {
    public currentCart: Cart;
    private currentContainer: JQuery;
    private configuration: SendTicketsConfiguration;
    private productSection: ProductSection;
    private employeeSection: EmployeeSection;
    private recipientSection: RecipientSection;
    private summarySection: SummarySection;
    private wizard: Wizard;
    private checkoutButton: JQuery;
    private scheduleButton: JQuery;
    private recurring: JQuery;
    private shortcutButtons: JQuery;
    private clickBackToEmployees: JQuery;
    private clickBackToTicketTypes: JQuery;
    private showRecipients: JQuery;
    private hideRecipients: JQuery;
    private notification: JQuery;
    private changeReference: JQuery;
    private changeScheduleDate: JQuery;
    private changeScheduledEndDate: JQuery;
    private schduledDatePickerInput: JQuery;
    private scheduledEndDatePickerInput: JQuery;
    private scheduleDateSelector: JQuery;
    private confirmReference: JQuery;
    private selectedReferenceContainer: JQuery;
    private selectReferenceContainer: JQuery;
    private selectInvoiceReference: JQuery;
    private activeReference: JQuery;
    private cancelChangeRefButton: JQuery;
    private predefinedReferenceButton: JQuery;
    private selectedDateSelected: JQuery;
    private selectedEndDateSelected: JQuery;
    private scheduleEndDate: JQuery;
    private defaultDateSelected: JQuery;
    private endDateSelected: JQuery;
    private selectedScheduledSendDate: JQuery;
    private selectedScheduledEndDate: JQuery;
    private scheduleInterval: JQuery;
    private tooManyTickets: JQuery;

    constructor(private container: JQuery) {
        this.currentContainer = container;
        this.configuration = new SendTicketsConfiguration(container);
        this.productSection =
            new ProductSection(container,
                this.configuration.productsUrl,
                this.configuration.fixedFromZones,
                this.setCartProductProperties.bind(this),
                this.shouldHideZoneSelection.bind(this),
                this.configuration.hideZones);
        this.employeeSection =
            new EmployeeSection(container,
                this.configuration.employeesUrl,
                this.configuration.csvUrl,
                this.configuration.validateHjhPhoneNumberUrl,
                this.configuration.validateForWhitelistProductTypeId,
                this.addRecipientToCart.bind(this),
                this.updateRecipientList.bind(this));
        this.recipientSection = new RecipientSection(container, this.removeRecipientFromCart.bind(this));
        this.summarySection = new SummarySection(container,
            this.configuration.summaryUrl,
            this.configuration.maxAmountPurchaseableTickets,
            this.shouldHideZoneSelection.bind(this));
        this.wizard = new Wizard(container);
        this.currentCart = new Cart();
        this.checkoutButton = $('#tmp_submit');
        this.scheduleButton = $('#Schedule');
        this.recurring = $('#Recurring');
        this.shortcutButtons = $('.shortcutButton');
        this.changeScheduleDate = $(".change-schedule-date");
        this.changeScheduledEndDate = $(".change-scheduled-end-date");
        this.scheduleDateSelector = $(".schedule-date-selector");
        this.defaultDateSelected = $(".default-date-selected");
        this.endDateSelected = $(".scheduled-end-selected");
        this.selectedDateSelected = $(".selected-date-selected");
        this.selectedEndDateSelected = $(".selected-end-date-selected");
        this.selectedScheduledSendDate = $("#SelectedScheduledSendDate");
        this.selectedScheduledEndDate = $("#SelectedScheduledEndDate");
        this.scheduleEndDate = $(".schedule-end-date");
        this.scheduleInterval = $("#ScheduleInterval");
        this.selectedDateSelected.hide();
        this.selectedEndDateSelected.hide();
        this.scheduleEndDate.hide();
        //this.scheduleDateSelector.hide();
        this.changeReference = $('.change-reference');
        this.confirmReference = $('.confirm-reference');
        this.selectedReferenceContainer = $('.selected-invoice-reference-container');
        this.selectReferenceContainer = $('.select-invoice-reference-container');
        this.selectInvoiceReference = $('#SelectInvoiceReference');
        this.activeReference = $('.active-reference');
        this.predefinedReferenceButton = $('.predefined-reference-button');
        this.cancelChangeRefButton = $('.btn-cancel-change-ref');
        this.clickBackToEmployees = container.find('.click-back-to-employees');
        this.clickBackToTicketTypes = container.find('.click-back-to-ticket-types');
        this.showRecipients = container.find('.show-recipients');
        this.hideRecipients = container.find('.hide-recipients');
        this.notification = $('body').find('[data-notification-manager]');
        this.tooManyTickets = container.find('.too-many-tickets-message');

        this.schduledDatePickerInput = container.find('.daterange-single-with-time');
        this.schduledDatePickerInput.daterangepicker({
            autoUpdateInput: true,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            timePicker: true,
            timePicker24Hour: true,
            minYear: 1901,
            locale: {
                format: 'yyyy-MM-DD HH:mm',
                cancelLabel: 'Clear'
            }
        });

        let that = this;
        this.schduledDatePickerInput.on('cancel.daterangepicker', function () {
            that.updateSelectedScheduleDate("");
            that.currentCart.sendDate = null;
        });
        this.schduledDatePickerInput.on('apply.daterangepicker', function (ev, picker) {
            that.updateSelectedScheduleDate(picker.startDate.format('YYYY-MM-DD HH:mm'));
            that.currentCart.sendDate = that.addTimeZone(picker.startDate);
        });

        this.schduledDatePickerInput.on('hide.daterangepicker', function (ev, picker) {
            that.updateSelectedScheduleDate(picker.startDate.format("YYYY-MM-DD HH:mm"));
            that.currentCart.sendDate = that.addTimeZone(picker.startDate);
        });

        this.scheduleInterval.on('change', function () {
            let interval = $(this).val();
            if (interval !== '') {
                that.scheduleEndDate.show();
            }
            else {
                that.scheduleEndDate.hide();
            }
            that.currentCart.interval = interval;
        });

        this.scheduledEndDatePickerInput = container.find('.daterange-single-with-end-date');
        this.scheduledEndDatePickerInput.daterangepicker({
            autoUpdateInput: true,
            singleDatePicker: true,
            showDropdowns: true,
            autoApply: true,
            timePicker: true,
            timePicker24Hour: true,
            minYear: 1901,
            locale: {
                format: 'yyyy-MM-DD HH:mm',
                cancelLabel: 'Clear'
            }
        });

        this.scheduledEndDatePickerInput.on('cancel.daterangepicker', function () {
            that.updateSelectedScheduledEndDate("");
            that.currentCart.endDate = null;
        });
        this.scheduledEndDatePickerInput.on('apply.daterangepicker', function (ev, picker) {
            that.updateSelectedScheduledEndDate(picker.startDate.format('YYYY-MM-DD HH:mm'));
            that.currentCart.endDate = that.addTimeZone(picker.startDate);
        });

        this.scheduledEndDatePickerInput.on('hide.daterangepicker', function (ev, picker) {
            that.updateSelectedScheduledEndDate(picker.startDate.format("YYYY-MM-DD HH:mm"));
            that.currentCart.endDate = that.addTimeZone(picker.startDate);
        });

        this.initialize();
    }

    public addTimeZone(date:any) {
        var formattedDate = date.format('YYYY-MM-DD HH:mm');

        function pad(number, length) {
            var str = '' + number;
            while (str.length < length) {
                str = '0' + str;
            }
            return str;
        }

        var timeZoneOffset = new Date().getTimezoneOffset();
        var offsetHours = Math.abs(timeZoneOffset / 60);
        var offsetMinutes = Math.abs(timeZoneOffset % 60);
        var timeZoneFormatted = (timeZoneOffset > 0 ? "-" : "+") +
            pad(offsetHours.toString(), 2) + ":" +
            pad(offsetMinutes.toString(), 2);
        return formattedDate + ' ' + timeZoneFormatted;
    }

    public checkout() {
        const confirmationMessage = this.container.find('.order-confirmation-message');
        this.currentCart.comment = this.summarySection.comment.val();
        this.currentCart.invoiceReference = this.activeReference.html();
        this.wizard.showLoading();

        let application = this;
        $.ajax({
            url: this.configuration.checkoutUrl,
            data: this.currentCart,
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                confirmationMessage.append(data.message);
                application.wizard.showOrderConfirmation();
                const step3FinishTitle = $('#step-3-finish-title');
                const step3ScheduledContainer = $("#step-3-finish-container");
                // If scheduled we get different response
                if (data.id) {
                    const a = $("#step-3-scheduled-link");
                    step3FinishTitle.hide();
                    step3ScheduledContainer.show();
                    var link = a.prop("href");
                    a.prop("href", link.replace('{0}', data.id));
                } else {
                    const invalidCount = data.invalidRecipientsCount;
                    var recipientsCount = 0;
                    application.currentCart.recipients.forEach(recipient => {
                        recipientsCount = recipientsCount + recipient.count;
                    });
                    const ticketCount = (recipientsCount - invalidCount);
                    step3ScheduledContainer.hide();
                    step3FinishTitle.text(step3FinishTitle.text().replace('{0}', ticketCount.toString()));
                }

            },
            error: function (data) {
                const json = data.responseJSON;
                let message = json.Message;
                if (!message) {
                    message = `${json.status} ${json.title}`;
                }
                Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
                application.notification.show();
                application.wizard.showRestart();
            }
        });
    }

    setCartProductProperties(productTypeId: string, productId: string, zoneType: string, zoneFrom: string,
        zoneTo: string, ticketMaxCount: number): void {
        if (productId) {
            this.currentCart.productId = productId;
        }

        if (productTypeId) {
            this.currentCart.productTypeId = productTypeId;
        }

        if (zoneType) {
            this.currentCart.zoneType = zoneType;
        }

        this.currentCart.zoneFrom = zoneFrom;
        this.currentCart.zoneTo = zoneTo;
        this.currentCart.productTypeTicketMaxCount = ticketMaxCount;
        this.currentCart.friendlyCombination = this.productSection.getFriendlyCombination();

        this.summarySection.updateTicket(this.currentCart);
    }

    shouldHideZoneSelection(productTypeId: string) {
        return this.configuration.shouldHideZoneSelectionProductTypeIds.includes(productTypeId);
    }

    addRecipientToCart(request: AddRecipientToCartRequest) {
        this.recipientSection.addRecipientToCart(this.currentCart, request);
    }

    removeRecipientFromCart(id: string) {
        let existingIndex = this.currentCart.recipients.findIndex(x => x.id === id);

        if (existingIndex >= 0) {
            this.currentCart.recipients.splice(existingIndex, 1);
        }
    }

    updateRecipientList(): void {
        this.recipientSection.updateRecipientList(this.currentCart);
        this.summarySection.updateSummary(this.currentCart);
    }

    clickShortcut(evt: JQueryEventObject) {
        let button = $(evt.currentTarget);
        const ticketType = button.attr('data-ticket-type');
        const travelType = button.attr('data-travel-type');
        const zoneType = button.attr('data-zone-type');
        const zoneFrom = button.attr('data-zone-from');
        const zoneTo = button.attr('data-zone-to');
        const maxAmount = button.attr('data-max-amount');

        $('#SelectedProductTypeId').val(ticketType);
        $('#SelectedFromZone').val(zoneFrom);
        $('#SelectedToZone').val(zoneTo);
        const dest = this.container.find('#SelectedProductId');
        const application = this;

        $.ajax({
            url: this.configuration.productsUrl + '?productTypeId=' + ticketType,
            dataType: 'json',
            success: function (data) {
                dest.empty();
                $(data).each(function () {
                    $('<option />', {
                        val: this.id,
                        text: this.profileName
                    }).appendTo(dest);
                });

                dest.val(travelType);
                application.setCartProductProperties(ticketType, travelType, zoneType, zoneFrom, zoneTo, parseInt(maxAmount));
                application.wizard.showEmployees();
            }
        });
    }

    clickCancelOrder() {
        this.reset();
        this.productSection.reset();
        this.wizard.reset();
        this.employeeSection.reset();
    }

    clickShowRecipient() {
        this.showRecipients.hide();
        this.hideRecipients.show();
        $('.recipient-hidden-area').slideDown();
    }

    clickHideRecipient() {
        this.showRecipients.slideDown('slow');
        this.hideRecipients.hide();
        $('.recipient-hidden-area').slideUp();
    }

    clickChangeInvoiceReference() {
        this.selectedReferenceContainer.hide();
        this.selectReferenceContainer.show();
    }

    updateSelectedScheduleDate(val: string) {
        this.selectedScheduledSendDate.val(val);
        if (val !== null && val !== undefined && val.length > 0) {
            this.defaultDateSelected.hide();
            this.selectedDateSelected.text(val);
            this.selectedDateSelected.show();
        } else {
            this.defaultDateSelected.show();
            this.selectedDateSelected.hide();
        }
    }

    updateSelectedScheduledEndDate(val: string) {
        this.selectedScheduledEndDate.val(val);
        if (val !== null && val !== undefined && val.length > 0) {
            this.endDateSelected.hide();
            this.selectedEndDateSelected.text(val);
            this.selectedEndDateSelected.show();
        } else {
            this.endDateSelected.show();
            this.selectedEndDateSelected.hide();
        }
    }

    clickChangeScheduleDate(evt: JQueryEventObject) {
        evt.preventDefault();
        // chrome fix
        this.schduledDatePickerInput.focus();
        this.schduledDatePickerInput.focus();
    }

    clickChangeScheduledEndDate(evt: JQueryEventObject) {
        evt.preventDefault();
        // chrome fix
        this.scheduledEndDatePickerInput.focus();
        this.scheduledEndDatePickerInput.focus();
    }

    clickConfirmInvoiceReference() {
        if (this.confirmReference.is(':checked') && !this.tooManyTickets.is(":visible")) {
            this.checkoutButton.removeClass('disabled');
            this.scheduleButton.removeClass('disabled');
        } else {
            this.checkoutButton.addClass('disabled');
            this.scheduleButton.addClass('disabled');
        }
    }

    changeSelectedReference() {
        if (this.selectInvoiceReference.val() !== '') {
            this.activeReference.html(this.selectInvoiceReference.val());
        }

        this.checkoutButton.addClass('disabled');
        this.scheduleButton.addClass('disabled');
        this.confirmReference.prop('checked', false);
        this.selectedReferenceContainer.show();
        this.selectReferenceContainer.hide();
    }

    clickPredefinedReferenceButton(evt: JQueryEventObject) {
        this.activeReference.html($(evt.currentTarget).html());
        this.checkoutButton.addClass('disabled');
        this.scheduleButton.addClass('disabled');
        this.confirmReference.prop('checked', false);
        this.selectedReferenceContainer.show();
        this.selectReferenceContainer.hide();
    }

    cancelChangeRef() {
        this.selectedReferenceContainer.show();
        this.selectReferenceContainer.hide();
    }

    reset() {
        this.currentCart = new Cart();
        this.summarySection.updateTicket(this.currentCart);
        this.clickHideRecipient();
    }

    private initialize() {
        this.checkoutButton.on('click', (evt) => this.checkout(evt));
        this.shortcutButtons.on('click', (evt) => this.clickShortcut(evt));
        this.clickBackToEmployees.on('click', (evt) => this.clickCancelOrder());
        this.clickBackToTicketTypes.on('click', (evt) => this.clickCancelOrder());
        this.showRecipients.on('click', (evt) => this.clickShowRecipient());
        this.hideRecipients.on('click', (evt) => this.clickHideRecipient());
        this.changeReference.on('click', (evt => this.clickChangeInvoiceReference()));
        this.changeScheduleDate.on('click', (evt => this.clickChangeScheduleDate(evt)));
        this.changeScheduledEndDate.on('click', (evt => this.clickChangeScheduledEndDate(evt)));
        this.confirmReference.on('click', (evt => this.clickConfirmInvoiceReference()));
        this.selectInvoiceReference.on('change', (evt => this.changeSelectedReference()));
        this.cancelChangeRefButton.on('click', (evt => this.cancelChangeRef()));
        this.predefinedReferenceButton.on('click', (evt => this.clickPredefinedReferenceButton(evt)));
    }
}
